import React from 'react';
import { Modal } from 'fronton-react/modal';
import { Portal } from 'fronton-react';
import { Breakpoint } from 'types/utils';
import { ModalLayoutTouch } from './content-blocks/modal-layout-touch';
import { PictureSources } from './photos-modal.types';
import { ModalLayoutDesktop } from './content-blocks/modal-layout-desktop';

export type PhotosModalProps = {
  breakpoint: Breakpoint;
  photos: PictureSources[];
  showedPicture: PictureSources | null;
  atSSR: boolean;
  isCheckedGallery?: boolean;
  hasMorePhotos?: boolean;
  isShowed?: boolean;
  setShowedPicture: (pic: PictureSources | null) => void;
  onCloseModal: () => void;
  onRequestMorePhotos?: () => void;
} & React.HTMLAttributes<HTMLElement>;

export const PhotosModal: React.FC<PhotosModalProps> = ({
  breakpoint,
  photos,
  showedPicture,
  hasMorePhotos = false,
  isCheckedGallery = false,
  atSSR,
  className = '',
  isShowed = false,
  setShowedPicture,
  onCloseModal,
  onRequestMorePhotos = () => null,
  ...htmlProps
}) => {
  const atDesktop = breakpoint === 'large' || breakpoint === 'medium';
  const atTouch = breakpoint === 'tablet' || breakpoint === 'mobile';

  return (
    <>
      {!atSSR && (
        <Portal>
          <Modal
            className={className}
            modalID="reviews-photos-modal_mf-pdp"
            onClose={onCloseModal}
            show={isShowed}
            size="l"
            variant="full-screen"
            overlayClose
            closeButton={false}
            {...htmlProps}
          >
            {atDesktop && (
              <ModalLayoutDesktop
                breakpoint={breakpoint}
                photosThumbs={photos}
                showedPicture={showedPicture}
                onClose={onCloseModal}
                setShowedPicture={setShowedPicture}
                onRequestMorePhotos={onRequestMorePhotos}
                hasMorePhotos={hasMorePhotos}
                isCheckedGallery={isCheckedGallery}
              />
            )}

            {atTouch && (
              <ModalLayoutTouch
                breakpoint={breakpoint}
                photosThumbs={photos}
                showedPicture={showedPicture}
                onClose={onCloseModal}
                setShowedPicture={setShowedPicture}
                hasMorePhotos={hasMorePhotos}
                isCheckedGallery={isCheckedGallery}
                onRequestMorePhotos={onRequestMorePhotos}
              />
            )}
          </Modal>
        </Portal>
      )}
    </>
  );
};
